import { useState } from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import careiqapi from "../../../../api/careiqapi";
import { getPracticeId } from "../../../../config/practice";

// Delete action for UNSYNCED local-store documents (mis-uploads — "someone
// else's labs on this chart", QA 2026-09-03). Synced docs live in the Athena
// chart and must be removed in athenaNet, so the button only renders for
// local && !synced rows; the backend enforces the same rule (409).
const DeleteLocalDocButton = ({ procedure, patid, onDeleted }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const practiseid = getPracticeId();

  if (!procedure?.local || procedure?.synced) return null;

  const docid =
    procedure.clinicaldocumentid ??
    procedure.imagingresultid ??
    procedure.encounterdocumentid;
  const title =
    procedure.documentdescription || procedure.label || "this document";

  const doDelete = async () => {
    try {
      setBusy(true);
      setError("");
      const res = await careiqapi.delete(
        `/v1/fhir-mirror/${practiseid}/patient/${patid}/documents/local/${docid}`,
      );
      if (res?.status === 200) {
        setOpen(false);
        if (onDeleted) onDeleted(procedure);
      } else {
        setError(res?.message || "Delete failed");
      }
    } catch (e) {
      setError(e?.response?.data?.message || "Delete failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button
        title="Delete this uploaded document"
        onClick={() => setOpen(true)}
        className="inline-flex shadow-md items-center gap-1 rounded-xl text-[#C4342B] px-2.5 py-2 bg-white text-[12px] font-inter font-medium hover:opacity-90 focus:outline-none shrink-0 justify-center"
      >
        <DeleteOutlineIcon fontSize="small" />
        Delete
      </button>
      <Dialog open={open} onClose={() => !busy && setOpen(false)}>
        <DialogTitle>Delete document?</DialogTitle>
        <DialogContent>
          <div className="text-sm text-[#4B5563] max-w-[380px]">
            Permanently remove <b>{title}</b> from this chart? Use this for
            documents uploaded to the wrong patient. This cannot be undone from
            the app.
          </div>
          {error && (
            <div className="text-sm text-[#C4342B] mt-2">{error}</div>
          )}
        </DialogContent>
        <DialogActions>
          <Button disabled={busy} onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            disabled={busy}
            onClick={doDelete}
          >
            {busy ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteLocalDocButton;
